(function () {
  'use strict';
  document.querySelectorAll('[data-dk-cookie-preferences]').forEach((button) => {
    button.addEventListener('click', async () => {
      const status = document.getElementById(button.getAttribute('aria-describedby'));
      button.disabled = true;
      try {
        if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('unavailable');
        await window.privacyBanner.showPreferences();
        if (status) status.hidden = true;
      } catch (_) {
        if (status) status.hidden = false;
      } finally {
        button.disabled = false;
      }
    });
  });
}());

